import moment from "moment";
import store from "@/store";
import { inToMile } from "@/tools/unit-conversion";
import {
  radarSnowColorData,
  radarRainColorData,
  radarSleetColorData,
  cloudsColorData,
  drivingDifficultyIceColorData,
  drivingDifficultySnowColorData,
  drivingDifficultyPondingColorData,
  drivingDifficultyWetColorData,
  drivingDifficultyFogColorData,
  drivingDifficultyWindColorData,
  weatherAlertColorData,
  statesArrayData,
} from "../../../weather/components/map-layer/config";
import { localStoreServer } from "@/utils/local-store";
import mapWeatherConfig from "@/config/map-weather";
import createApiWorker from "./worker";
import { cloneDeep } from "lodash";

let undoList = cloneDeep(statesArrayData),
  runningList = [],
  cachZonesData = {};
export function getPolygonNum(data) {
  let type = store.state.mapWeather.weatherType;
  let arr = [];
  let iceAccumulation = isHasValue(data.iceAccumulation.values);
  let snowfallAmount = isHasValue(data.snowfallAmount.values);
  if (iceAccumulation) {
    arr.push({
      flag: type === "radarClouds" ? "radarSleet" : "drivingDifficultyIce",
      value: iceAccumulation,
    });
  } else if (snowfallAmount) {
    arr.push({
      flag: type === "radarClouds" ? "radarSnow" : "drivingDifficultySnow",
      value: snowfallAmount,
    });
  }
  if (type === "radarClouds") {
    let probabilityOfPrecipitation = isHasValue(
      data.probabilityOfPrecipitation.values
    );
    if (probabilityOfPrecipitation) {
      arr.push({
        flag: "radarRain",
        value: probabilityOfPrecipitation,
      });
    }
  } else {
    let ponding = isHasValue(data.quantitativePrecipitation.values);
    let fog = isHasValue(data.visibility.values);
    let windSpeed = isHasValue(data.windSpeed.values);
    let wet = isHasValue(data.relativeHumidity.values);
    if (ponding) {
      arr.push({
        flag: "drivingDifficultyPonding",
        value: ponding,
      });
    } else if (fog) {
      arr.push({
        flag: "drivingDifficultyFog",
        value: fog,
      });
    } else if (windSpeed) {
      arr.push({
        flag: "drivingDifficultyWind",
        value: windSpeed,
      });
    } else if (wet) {
      arr.push({
        flag: "drivingDifficultyWet",
        value: wet,
      });
    }
  }
  return arr;
}
function filterValueColor(type, value) {
  let fillColor = "",
    colorData = [];
  // filter type
  switch (type) {
    case "radarSnow":
      colorData = radarSnowColorData;
      break;
    case "radarRain":
      colorData = radarRainColorData;
      break;
    case "radarSleet":
      colorData = radarSleetColorData;
      break;
    case "clouds":
      colorData = cloudsColorData;
      break;
    case "drivingDifficultyIce":
      colorData = drivingDifficultyIceColorData;
      break;
    case "drivingDifficultySnow":
      colorData = drivingDifficultySnowColorData;
      break;
    case "drivingDifficultyPonding":
      colorData = drivingDifficultyPondingColorData;
      break;
    case "drivingDifficultyWet":
      colorData = drivingDifficultyWetColorData;
      break;
    case "drivingDifficultyFog":
      colorData = drivingDifficultyFogColorData;
      break;
    case "drivingDifficultyWind":
      colorData = drivingDifficultyWindColorData;
      break;
  }
  for (let i = 0; i < colorData.length; i++) {
    let item = colorData[i];
    if (item.in.length == 1) {
      if (value > item.in[0]) {
        fillColor = item.out;
        break;
      }
    } else {
      if (item.in[0] < value && value < item.in[1]) {
        fillColor = item.out;
        break;
      }
    }
  }
  return fillColor;
}
export function layerFilterColor(data) {
  let difficultyFilterColorObj = {
    strokeWeight: 0,
    strokeOpacity: 0,
    fillOpacity: 0.7,
    strokeColor: "#000000",
  };
  if (data.flag === "radarSnow" || data.flag === "drivingDifficultySnow") {
    difficultyFilterColorObj.fillColor = filterValueColor(
      data.flag,
      data.value / 304.8
    );
  } else if (data.flag === "drivingDifficultyFog") {
    difficultyFilterColorObj.fillColor = filterValueColor(
      data.flag,
      inToMile(data.value)
    );
  } else {
    difficultyFilterColorObj.fillColor = filterValueColor(
      data.flag,
      data.value
    );
  }
  return difficultyFilterColorObj;
}
function isHasValue(data) {
  let date = moment().format("YYYY-MM-DD");
  if (store.state.mapWeather.currentTimeIsSecondDay) {
    date = moment()
      .add(1, "days")
      .format("YYYY-MM-DD");
  }
  if (data.length) {
    const result = data.find((item) => {
      const dateJudge = item.validTime.split("T")[0] === date;
      if (dateJudge && hoursJudgeF(item)) {
        return true;
      }
      return false;
    });
    return result?.value;
  }
}
function hoursJudgeF(item) {
  let legendCurrentTimeH = store.state.mapWeather.weatherAlertLegendCurrentTime.split(
    ":"
  )[0];
  let validTimeH = item.validTime.split("T")[1].split(":")[0];
  let arr = [6, 12, 18, 24];
  legendCurrentTimeH = findCloseNum(arr, legendCurrentTimeH);
  legendCurrentTimeH === 24 ? 0 : legendCurrentTimeH;
  if (validTimeH == legendCurrentTimeH) {
    return true;
  }
}
export function alertsFeatureFilterColor(item) {
  let alertsFeatureColorObj = { strokeWeight: 0.5, strokeOpacity: 1 };
  let severityArr = ["Unknown", "Minor", "Moderate", "Severe", "Extreme"];
  let fillOpacityIndex = severityArr.indexOf(item.severity);
  if (fillOpacityIndex != -1) {
    alertsFeatureColorObj.fillOpacity =
      (0.1 + fillOpacityIndex / 10).toFixed(1) / 1;
  } else {
    alertsFeatureColorObj.fillOpacity = 0.1;
  }
  if (item.event) {
    for (let alertColor of weatherAlertColorData) {
      if (item.event === alertColor.title) {
        alertsFeatureColorObj.strokeColor =
          alertColor.borderColor || alertColor.color;
        alertsFeatureColorObj.fillColor = alertColor.color;
      }
    }
    if (
      !alertsFeatureColorObj.strokeColor ||
      !alertsFeatureColorObj.fillColor
    ) {
      store.commit("mapWeather/SET_LEGEND_IS_SHOW_OTHER_TYPE", true);
      item.title = "Other";
      alertsFeatureColorObj.strokeColor = "#3D3A52";
      alertsFeatureColorObj.fillColor = "#3D3A52";
    }
  }
  return alertsFeatureColorObj;
}
export function filterCurrentActiveAlertsItem(id) {
  const item = store.state.mapWeather.alertsActiveList.find((item) =>
    item?.properties?.affectedZones.includes(id)
  );
  return item?.properties ?? {};
}
/**
 * @method
 * @param {array} arr
 * @param {number} targetNum
 * @return {number}
 * @desc
 */
function findCloseNum(arr, num) {
  var index = 0;
  num = num / 1;
  var d_value = Number.MAX_VALUE;
  for (var i = 0; i < arr.length; i++) {
    var new_d_value = Math.abs(arr[i] - num);
    if (new_d_value <= d_value) {
      if (new_d_value === d_value && arr[i] < arr[index]) {
        continue;
      }
      index = i;
      d_value = new_d_value;
    }
  }
  return arr[index];
}
export function filterTime(value, type) {
  let hours = value.split(":")[0] / 1,
    mins = value.split(":")[1],
    newHours = null;
  if (type === "start") {
    store.commit("mapWeather/SET_CURRENT_TIME_IS_YESTERDAY", false);
    newHours = hours - 2;
    if (newHours < 0) {
      newHours = newHours < 0 ? 24 - Math.abs(newHours) : newHours;
      store.commit("mapWeather/SET_CURRENT_TIME_IS_YESTERDAY", true);
    }
  } else {
    store.commit("mapWeather/SET_CURRENT_TIME_IS_YESTERDAY", false);
    newHours = hours + 2;
    if (newHours >= 24) {
      newHours = newHours > 24 ? newHours - 24 : newHours;
      store.commit("mapWeather/SET_CURRENT_TIME_IS_YESTERDAY", true);
    }
  }
  newHours = (newHours + "").length < 2 ? "0" + newHours : newHours + "";
  return newHours + ":" + mins;
}
export async function filterS3ZonesData(value) {
  let str = value.substring(0, 2),
    ZonesData = null;
  if (!cachZonesData[str]) {
    ZonesData = await localStoreServer._localforageGet(
      "mapWeatherVersion2" + str
    );
    cachZonesData[str] = ZonesData;
  }
  ZonesData = cachZonesData[str];
  if (!ZonesData) return;
  const result = ZonesData.find(
    (item) => item && Object.keys(item)[0] === value
  );
  const ZonesData2 = result?.[value] || [];
  return ZonesData2.length >= 3 ? ZonesData2 : [];
}
export function scatteredS3ZonesData(arr) {
  let newArr = [];
  for (let item of arr) {
    let firstValue = item.splice(0, 1);
    let lastValue = item.splice(item.length - 1, 1);
    let result = [];
    result = sampleArray(item);
    result.unshift(...firstValue);
    result.push(...lastValue);
    newArr.push(result);
  }
  return newArr;
}
function sampleArray(arr) {
  let n = arr.length;
  let scatteredS3ZonesDataStep = mapWeatherConfig.scatteredS3ZonesDataStep;
  if (n < scatteredS3ZonesDataStep) {
    return arr;
  } else {
    let step = Math.ceil(n / scatteredS3ZonesDataStep);
    return arr
      .filter((_, i) => i % step == 0)
      .slice(0, scatteredS3ZonesDataStep);
  }
}
function unique(arr, val) {
  const res = new Map();
  return arr.filter((item) => !res.has(item[val]) && res.set(item[val], 1));
}
function isInAmericaStates(geocode) {
  const statesArrayCodes = new Set(statesArrayData.map((state) => state.code));
  const arr = JSON.parse(geocode);
  for (let code of arr.map((item) => item.substring(0, 2))) {
    if (statesArrayCodes.has(code)) {
      return true;
    }
  }
  return false;
}
export function updataAlertsActiveList(value) {
  let arr = [],
    typeListArr = [];
  arr = store.state.mapWeather.alertsActiveOriginList.filter((item) => {
    return (
      (item.onset && item.onset <= value && value <= item.ends) ||
      (item.onset && item.onset <= value && !item.ends)
    );
  });
  let weatherAlertsCheckboxList = JSON.parse(
    localStorage.getItem(
      `weatherAlertsCheckboxList${store.state.user.userId || ""}`
    )
  );
  // filter typeList
  const checkboxObj =
    (weatherAlertsCheckboxList &&
      weatherAlertsCheckboxList.reduce((obj, title) => {
        obj[title] = true;
        return obj;
      }, {})) ||
    {};
  arr
    .filter((item) => isInAmericaStates(item.geocode))
    .forEach((item) => {
      const item2 = weatherAlertColorData.find((i) => i.title === item.event);
      if (item2) {
        item2.legendChecked = !checkboxObj[item2.title];
        typeListArr.push(item2);
      }
    });
  typeListArr = unique(typeListArr, "title");
  store.commit("mapWeather/SET_WEATHER_ALERT_TYPES_LIST", typeListArr);
  store.commit("mapWeather/SET_ALERT_ACTIVE_LIST", arr);
}
const getNextTask = (apiWorker) => {
  const item = undoList.shift();
  if (item) {
    runningList.push(item);
    console.log("apiWorker item", item);
  } else {
    !runningList.length &&
      store.commit("mapWeather/SET_S3ZONESDATA_IS_DOWNLOAD_COMPLETE", true);
    console.log("apiWorker close");
    localStorage.setItem(
      `S3ZonesDataIsDownloadComplete${store.state.user.userId || ""}`,
      "true"
    );
    apiWorker.terminate();
  }
  return item;
};

function stringifyData(data) {
  const result = [];
  for (const item of data) {
    const key = item && Object.keys(item)[0];
    if (!key) {
      continue;
    }
    const arr = item[key]?.geometry?.coordinates || [];
    const newArr = arr.filter(Boolean).map(JSON.stringify);
    if (newArr.length) {
      result.push({ [key]: newArr });
    }
  }
  console.log("stringifyData", result);
  return result;
}
export function initApiWorker() {
  let S3ZonesDataIsDownloadComplete = localStorage.getItem(
    `S3ZonesDataIsDownloadComplete${store.state.user.userId || ""}`
  );
  if (S3ZonesDataIsDownloadComplete === "true") {
    store.commit("mapWeather/SET_S3ZONESDATA_IS_DOWNLOAD_COMPLETE", true);
    return;
  }
  let workerList = [];
  for (let i = 0; i < mapWeatherConfig.maximum; i++) {
    workerList.push(createApiWorker());
  }
  workerList.forEach((apiWorker) => {
    apiWorker.onmessage = (e) => {
      let res = e.data;
      if (res.code == 200) {
        try {
          localStoreServer._localforageSet(
            "mapWeatherVersion2" + res.stateCode,
            stringifyData(res.data[res.stateCode])
          );
          if (store.state.mapWeather.statesInBounds.includes(res.stateCode)) {
            store.commit(
              "mapWeather/SET_INBOUNDS_IS_DOWNLOAD_COMPLETE_FLAG",
              true
            );
          }
          runningList = runningList.filter((x) => x.code !== res.stateCode);
          console.log("apiWorker success", res.stateCode);
          const item = getNextTask(apiWorker);
          item && getFleetWeatherAlertLocationFn(apiWorker, item);
        } catch (reason) {
          console.log("apiWorker error, no retry", res.stateCode, reason);
        }
      } else {
        console.log("apiWorker error", res.stateCode, res);
        const item = runningList.filter((x) => x.code === res.stateCode)[0];
        item && getFleetWeatherAlertLocationFn(apiWorker, item);
      }
    };
    const item = getNextTask(apiWorker);
    item && getFleetWeatherAlertLocationFn(apiWorker, item);
  });
}
export async function getFleetWeatherAlertLocationFn(apiWorker, item) {
  // from undo pick up one move it to running;
  // if undo is empty. finish self
  console.log("undoList", undoList);

  let ZonesData = await localStoreServer._localforageGet(
    "mapWeatherVersion2" + item.code
  );
  if (!ZonesData) {
    store.commit("mapWeather/SET_INBOUNDS_IS_DOWNLOAD_COMPLETE_FLAG", false);
    apiWorker.postMessage({ stateCode: item.code });
    // remove item from running
  } else {
    console.log("apiWorker exist", item.code);
    runningList = runningList.filter((x) => x.code !== item.code);
    const item2 = getNextTask(apiWorker);
    item2 && getFleetWeatherAlertLocationFn(apiWorker, item2);
  }
}
export function filterExistingStates(arr, item, stateCode) {
  // filter same alert and same affected area
  let newArr = arr.filter(
    (x) => x.event === item.event && x.stateCode === stateCode
  );
  // console.log("filterExistingStates", newArr, arr, item, stateCode);
  return newArr.length;
}
export function filterDifferenceAlertSameAffectedArea(arr, item) {
  // filter difference alert and same affected area
  let newArr = arr.filter((x) => x.event === item.event);
  return newArr.length;
}
export function converterDrawWeatherAlert(arr) {
  const newArr = [];
  for (let item of arr) {
    const newArr2 = item
      .filter((item2) => item2)
      .map((item2) => JSON.parse(item2));
    if (newArr2.length) {
      newArr.push(newArr2);
    }
  }
  return newArr;
}
